import React, { Component } from "react";
import { connect } from "react-redux";
import { config } from "../../_config/_config";
class Footer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    // Construct footer background image URL
    const footerBgImage = config.assetUrl
      ? `${config.assetUrl}${config.assetUrl.endsWith('/') ? '' : '/'}${config.assetBrandName}_footer_image.jpg`
      : `/${config.assetBrandName}_footer_image.jpg`;

    const footerContnrStyle = {
      backgroundImage: `url(${footerBgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      backgroundColor: '#010101'
    };

    return (
      <div className="outer_application_form fs-outer_application_form">
        <footer>
          <div className="copyright-contnr">
            <div className="wrapper">
              <section className="container">
                <strong>
                  <strong>
                    <span>
                      <small><i>Powered by </i></small> EMBERA
                    </span>
                  </strong>
                </strong>
              </section>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Footer);
export { connectedApp as Footer };
